import React, { useEffect, useRef, useState } from 'react'
import useSound from 'use-sound'
import bell from '../../../assets/sounds/message4.mp3'

const SoundRepeat5 = () => {
	const [play, { stop }] = useSound(bell, { interrupt: false })
	const [refresh, setRefresh] = useState(false)


	useEffect(() => {
		console.log("PLAY5")
		play({
			forceSoundEnabled: true,
		})
		setTimeout(() => {
			setRefresh(!refresh)
		}, 60*1000*5)
	}, [refresh])

	useEffect(() => {
		setTimeout(() => {
			setRefresh(!refresh)
		}, 200)

		return () => {
			stop()
		}
	}, [])


	return <></>
}
export default SoundRepeat5
